module.exports = __webpack_public_path__ + "static/Karol-Andrade-83920852583cd6ff84b86f78941a8fb7.png";